import request from '@/http/axios'

// 获取订单详情
export function getOrderDetails (data) {
  return request({
    url: `/order/order-detail-base64-flexible?orderNo=${data.orderNo}&pageType=${data.pageType}`,
    method: 'POST'
  })
}

// 获取展期订单详情
export function getExtensionDetail (data) {
  return request({
    url: '/delay/calculate-delay-flexible',
    method: 'POST',
    data
  })
}
// 拆分还款跳转地址
export function getSplitRepaymentUrl (data) {
  return request({
    url: '/order/generate-repayment-code',
    method: 'POST',
    data
  })
}

// 是否展示自动复借按钮
export function isShowAutoAppltBtn (data) {
  return request({
    url: `/order/show-auto-apply-new?orderNo=${data.orderNo}`,
    method: 'POST'
  })
}

// 是否自动复借
export function setAutoApplt (data) {
  return request({
    url: `/order/settled-auto-apply?orderNo=${data.orderNo}&type=${data.type}`,
    method: 'POST'
  })
}

// 自动复借弹窗的银行卡信息
export function bankDetails () {
  return request({
    url: '/auth/bank-card-list-base64',
    method: 'POST'
  })
}

// 获取还款详情
export function repaymentDetails (data) {
  return request({
    url: '/order/repayment-detail',
    method: 'POST',
    data
  })
}

// 更改utr
export function changeUtr (data) {
  const formDate = new FormData()
  if (data.img) {
    for (let index = 0; index < data.img.length; index++) {
      const file = data.img[index]
      formDate.append('img', file)
    }
  }
  return request({
    url: '/order/up-order-utr',
    method: 'POST',
    params: {
      orderNo: data.orderNo,
      utr: data.utr,
      amount: data.amount
    },
    data: data.img && data.img.length ? formDate : undefined,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 客服反馈
export function feedBack (data) {
  return request({
    url: '/user/complaint',
    method: 'POST',
    data
  })
}

// 获取客服信息
export function getCustomerInfo () {
  return request({
    url: '/common/customerServiceInfo',
    method: 'POST'
  })
}
